
<div>
  <template v-for="c in CONTEXTS">
    <slot :name="c" v-if="contextIs(c)"></slot>
  </template>
</div>
